<template>
    <div>
        <div class="search-container primary mb10 mt10">
            <div class="form-box">
                <input class="input-field" v-model="inqryTitle" placeholder="请输入询价单名称"/>
                <button class="search-btn" @click="getPriceReplyList()"><i class="icon iconfont icon-search"></i></button>
            </div>
        </div>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="priceReplyList" border tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange">
                <el-table-column width="55">
                    <template slot-scope="rows">
                        <div class="copy-radio" :class="{'circle' : checkPriceReply.id == rows.row.id}">
                            <div class="circle-dot"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="inqryVoucherNo" label="询价单号" align="center" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="inqryTitle" label="询价单名称" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" width="150" prop="contactName" label="联系人"></el-table-column>
                <el-table-column align="left" width="120" prop="contactTel" label="联系电话"></el-table-column>
                <el-table-column align="right" label="报价金额（元）" width="120" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span>{{parseFloat(rows.row.replyAmount).toFixed(2) || 0}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="replyTime" label="报价时间" width="180" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="block pagination-layout">
            <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import priceApi from '../../api/price'
    import { getDefaultPageSizes } from '../../../src/app.conf'

    export default{
        name: 'swb-price-reply-for-select',
        desc: '选择-报价信息',
        props: {
            merchantId: {
                type: Number
            },
            merchantType: {
                type: Number
            },
            inqryMerchantId: {
                type: Number
            },
            inqryMerchantType: {
                type: Number
            },
            rowId: {
                type: Number
            }
        },
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),

                inqryTitle: null,
                priceReplyList: [],
                checkPriceReply: {
                    id: null
                },
                checkPriceReplyInfo: null
            }
        },
        created: function () {
            if(this.rowId != null) {
                this.checkPriceReply.id = this.rowId;
            }
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            this.getPriceReplyList();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getPriceReplyList();
            },
            getPriceReplyList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                if(self.inqryTitle != null) {
                    filterItems.inqryTitle = self.inqryTitle;
                }
                filterItems.merchantId = self.merchantId;
                filterItems.merchantType = self.merchantType;
                filterItems.inqryMerchantId = self.inqryMerchantId;
                filterItems.inqryMerchantType = self.inqryMerchantType;
                filterItems.adopted = true;

                postData.filterItems = filterItems;
                let lastMsgBoxDlg = MsgBox.loading();
                priceApi.getPriceReplyVoucherList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        self.priceReplyList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleCurrentChange: function (val) {
                this.checkPriceReply.id = val.id;
                this.checkPriceReplyInfo = val;
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let checkPriceReplyInfo = self.checkPriceReplyInfo;
                if(checkPriceReplyInfo != null) {
                    result.type = 'info';
                    result.data = checkPriceReplyInfo;
                } else {
                    result.type = 'warn';
                    result.message = '至少选择一个报价单！';
                }
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/priceInpry/PriceReplyForSelect.vue